const React = require("react");
function IconApple(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.8346 4.34344c.8289-.8855 1.3912-2.11722 1.2382-3.34344-1.1982.04328-2.6459.7007-3.5044 1.58619-.7697.78314-1.4456 2.0389-1.2651 3.24108 1.3346.08862 2.6996-.59834 3.5313-1.48383m2.546 8.47166c-.0241-2.7506 2.1856-4.07098 2.2828-4.13486-1.241-1.86785-3.1765-2.12271-3.8655-2.15225-1.6468-.17174-3.2136.9954-4.0508.9954-.8317 0-2.1209-.97136-3.48516-.94731-1.79839.02954-3.45345 1.07372-4.37675 2.72654-1.86522 3.32488-.47613 8.25178 1.34017 10.94808.89092 1.3203 1.94928 2.8021 3.33768 2.7479 1.34296-.0536 1.84936-.8903 3.46656-.8903 1.6178 0 2.0726.8903 3.4886.8635 1.4428-.0268 2.3551-1.3472 3.235-2.6696 1.0204-1.5326 1.4401-3.0137 1.4642-3.0885-.0296-.0193-2.8071-1.1088-2.8368-4.3986",
    clipRule: "evenodd"
  }));
}
module.exports = IconApple;